import React from 'react';
import { useState, useEffect } from 'react'
import useLogin from './useLogin';
import './Login.css';
import PropTypes from 'prop-types';

async function loginUser(credentials) {
    return fetch(global.config.Api.url + '7FEF1C01-7B23-4B74-8211-2A622874AD0D/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(credentials)
    })
      .then(data => data.json())
   }



export default function Login({setEditor}) {
    const {login, setLogin} = useLogin() 
    const [solution, setSolution] = useState('');
    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [remember, setRemember] = useState(false);

    useEffect(() => {
      const getLogin = async () => {
        setSolution(login.Solution)
        setUserName(login.Username)
        setPassword(login.Password)
        setRemember(login.Remember)
      }
      getLogin()

  },[login])
  /*
     if(login){
      setSolution(login.Solution)
      setUserName(login.Username)
      setPassword(login.Password)
      setRemember(login.Remember)
     }
     */

    const handleSubmit = async e => {
        e.preventDefault();
        const token = await loginUser({
            Solution: solution,
            Username: username,
            Password: password
        });
        global.config.Editor = token
        global.config.Profile = token.profile
        setEditor(token);
        setLogin({
            Solution: remember && solution,
            Username: remember && username,
            Password: remember && password,
            Remember: remember
        })
      }
      
  return(
    <div className="login-wrapper">
      <h1>contentCLOUD login</h1>
      <form onSubmit={handleSubmit}>
        <label className="input_label">
          <span>Domain</span>
          <input type="text" required onChange={e => setSolution(e.target.value)} value={solution}/>
        </label>
        <label className="input_label">
          <span>Username</span>
          <input type="text" required onChange={e => setUserName(e.target.value)} value={username}/>
        </label>
        <label className="input_label">
          <span>Password</span>
          <input type="password" required onChange={e => setPassword(e.target.value)} value={password}/>
        </label>
        <label className="input_label">
          <span>Remeber me</span>
          <input type="checkbox" onChange={e => setRemember(e.target.value)} checked={remember}/>
        </label>
        <div className="align_right">
          <button type="submit" className="btn action-btn blue-gradient">Login</button>
        </div>
      </form>
    </div>
  )
}


Login.propTypes = {
    setEditor: PropTypes.func.isRequired
  }